import React from 'react';
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
//import { connect } from "react-redux";
import { translate } from "../../base/Translation";

/*eslint no-restricted-globals: 0 */

class PossibleAnswer extends React.Component {

	removeAnswer(evt) {
		if (confirm(translate("Ste si istý?")) === false) return;
		this.props.updateAnswer(this.props.answer, this.props.section, this.props.group, this.props.question, true);
	}

	onChange(evt) {
		let answer = this.props.answer;
		answer[evt.target.name] = evt.target.value;
		this.props.updateAnswer(answer, this.props.section, this.props.group, this.props.question, false);
	}
	
	render() {
		//const fixed_type = this.props.question.type === "true" || this.props.question.type === 1 || this.props.question.type === true ? 1 : 0;
		const other = this.props.answer.other === "true" || this.props.answer.other === 1 || this.props.answer.other === true ? 1 : 0;

		return (
			<Row key={this.props.answer.id} /*style={{ borderBottom: "1px solid silver", marginBottom: "1.5rem" }}*/>
				<Col lg={6}>
					<FormGroup className="form-group-sm">
						<ControlLabel className="visible-sm visible-xs">{translate("Odpoveď")}</ControlLabel>
						<FormControl defaultValue={this.props.answer.name} onBlur={this.onChange.bind(this)}
							name="name" />
					</FormGroup>
				</Col>
				<Col lg={2}>
					<FormGroup className="form-group-sm">
						<ControlLabel className="visible-sm visible-xs">{translate("Body")}</ControlLabel>
						<FormControl type="number" defaultValue={this.props.answer.points}
							onBlur={this.onChange.bind(this)}
							name="points" />
					</FormGroup>
				</Col>
				<Col lg={2}>
					<FormGroup className="form-group-sm">
						<ControlLabel className="visible-sm visible-xs">{translate("Iné")}</ControlLabel>
						<FormControl componentClass="select" defaultValue={other}
							onBlur={this.onChange.bind(this)} name="other">
							<option value="0">{translate("Nie")}</option>
							<option value="1">{translate("Áno")}</option>
						</FormControl>
					</FormGroup>
				</Col>
				<Col lg={2}>
					<FormGroup>
						<ControlLabel className="visible-sm visible-xs">{translate("Možnosti")}</ControlLabel>
						<button className="btn btn-danger btn-sm" onClick={this.removeAnswer.bind(this)}>
						<i className="fa fa-trash" />
					</button>
					</FormGroup>
				</Col>
			</Row>
		)
	}
}

export default PossibleAnswer;


// WEBPACK FOOTER //
// ./src/modules/form/edit/PossibleAnswer.js